import { isEmpty } from 'lodash'

const getParsedFields = (formFields = []) => {
  const parsedFields = !isEmpty(formFields) ? JSON.parse(formFields) : []
  const formFieldsKeys = Object.keys(parsedFields) || []

  const formFieldArray = formFieldsKeys.map((key) => ({
    name: key,
    id: key,
  }))

  return formFieldArray
}

export default getParsedFields
